import React, { useRef } from "react";
import { Box, Container, Grid, IconButton, Typography } from "@mui/material";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { ChevronRight, ChevronLeft, Link2 } from "react-feather";

const BestList = ({ linkData = [] }) => {
  const { t, i18n } = useTranslation();
  const containerRef = useRef(null);
  const scrollAmount = 300;

  const handleScroll = (direction) => {
    if (containerRef.current) {
      containerRef.current.scrollLeft +=
        direction === "next" ? scrollAmount : -scrollAmount;
    }
  };

  return (
    <Container maxWidth="lg" disableGutters>
      <Box className="w-full text-center">
        <Typography
          variant="h2"
          fontWeight="bold"
          color="#212F3D"
          textAlign="center"
          mt={2}
          mb={2}
        >
           {i18n.language === "en" ? "Partner organizations" : " Хамтрагч байгууллагууд"}
         
        </Typography>
      </Box>

      <Box position="relative" py={2} mb={8}>
        {linkData.length > 0 ? (
          <Box display="flex" alignItems="center">
            <IconButton onClick={() => handleScroll("prev")} sx={{ zIndex: 2 }}>
              <ChevronLeft />
            </IconButton>

            <Box
              ref={containerRef}
              sx={{
                display: "flex",
                justifyContent: "center",
                overflowX: "auto",
                scrollBehavior: "smooth",
                width: "100%",
                "&::-webkit-scrollbar": { display: "none" },
                scrollbarWidth: "none",
                msOverflowStyle: "none",
              }}
            >
              <Box display="flex" gap={2} pl={1}>
                {linkData.map((item) => (
                  <Box
                    key={item.id}
                    sx={{
                      flex: "0 0 auto",
                      // width: 350,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <Link href={item.link} passHref legacyBehavior>
                      <a style={{ textDecoration: "none", color: "inherit" }}>
                        <Box
                          sx={{
                            border: "1px solid #dee2e6",
                            borderRadius: 2,
                            overflow: "hidden",
                            // margin: 2,
                            boxShadow: "rgba(31, 45, 61, 0.125) 0px 0px 30px",
                          }}
                        >
                          <Box
                            sx={{
                              backgroundImage: `url(${item.imageUrl})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              width: 350,
                              height: 240,
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            fontSize: 18,
                            mt: -2,
                            px: 2,
                            py: 1.5,
                            backgroundColor: "#fff",
                            fontWeight: 800,
                            textAlign: "center",
                            borderRadius: 1,
                            color: "#3a3973",
                            boxShadow: "rgba(31, 45, 61, 0.125) 0px 0px 30px",
                          }}
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            gap={1}
                          >
                            <Link2 size={16} />
                            {i18n.language === "en"
                              ? item.descriptionEng
                              : item.description}
                          </Box>
                        </Box>
                      </a>
                    </Link>
                  </Box>
                ))}
              </Box>
            </Box>

            <IconButton onClick={() => handleScroll("next")} sx={{ zIndex: 2 }}>
              <ChevronRight />
            </IconButton>
          </Box>
        ) : (
          <Typography variant="h6" align="center">
            {t("No data available")}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default BestList;
